import React, {
    useCallback,
    useContext,
    useEffect,
    useState
} from "react";
import axios from "axios";
import {
    Redirect,
    Route,
    Switch
} from "react-router-dom";
import {
    Alert
} from "react-bootstrap";
import {
    TabBar,
    TabBarItem,
    Title
} from "@zandor300/backoffice-framework";
import ReactRouterPropTypes from "react-router-prop-types";

import ShopsContext from "../../../context/ShopsContext";
import Helmet from "../../../components/Helmet";

import DiscountCodeDetailOverview from "./DiscountCodeDetailOverview";
import DiscountCodeDetailProducts from "./DiscountCodeDetailProducts";
import DiscountCodeDetailEdit from "./DiscountCodeDetailEdit";

function DiscountCodeDetail({ match }) {
    const shopsContext = useContext(ShopsContext);
    const [discountCode, setDiscountCode] = useState(null);
    const [error, setError] = useState(null);

    const discountCodeId = parseInt(match.params.discountCodeId, 10);
    const baseUrl = "/shop/" + shopsContext.currentShop.codeName + "/discount-code/" + discountCodeId;

    const getDiscountCode = useCallback(() => {
        setDiscountCode(null);
        setError(null);
        axios.post("/getDiscountCode", {
            shopId: shopsContext.currentShop.id,
            discountCodeId,
        })
            .then((response) => {
                if(response.data.valid) {
                    setDiscountCode(response.data.discountCode);
                } else {
                    setError("Er ging iets fout. Probeer het later opnieuw. (" + response.data.error + ")");
                }
            })
            .catch(() => {
                setError("Er ging iets fout. Probeer het later opnieuw.");
            });
    }, [shopsContext.currentShop.id, discountCodeId]);

    useEffect(() => {
        getDiscountCode();
    }, [getDiscountCode]);

    return (
        <React.Fragment>
            <Helmet title={ discountCode ? discountCode.code : "Kortingscode" }/>
            <Title preTitle="Detail" noBottom>
                Kortingscode <small className="text-muted">#{discountCodeId}</small>
            </Title>

            <TabBar>
                <TabBarItem to={ baseUrl }>
                    Overzicht
                </TabBarItem>
                <TabBarItem to={ baseUrl + "/products" }>
                    Producten
                </TabBarItem>
                <TabBarItem to={ baseUrl + "/edit" }>
                    Bewerken
                </TabBarItem>
            </TabBar>

            { error ? (
                <Alert variant="danger">{ error }</Alert>
            ) : (
                <Switch>
                    <Route path={ baseUrl } exact>
                        <DiscountCodeDetailOverview discountCode={ discountCode }/>
                    </Route>
                    <Route path={ baseUrl + "/products" } exact>
                        <DiscountCodeDetailProducts
                            discountCode={ discountCode }
                            setDiscountCode={ setDiscountCode }
                        />
                    </Route>
                    <Route path={ baseUrl + "/edit" } exact>
                        <DiscountCodeDetailEdit
                            discountCode={ discountCode }
                            setDiscountCode={ setDiscountCode }
                        />
                    </Route>

                    <Route path="/">
                        <Redirect
                            to={{
                                pathname: baseUrl,
                                state: { from: "/" }
                            }}
                        />
                    </Route>
                </Switch>
            )}
        </React.Fragment>
    );
}
DiscountCodeDetail.propTypes = {
    match: ReactRouterPropTypes.match
}

export default DiscountCodeDetail;
